export function isMethod<T>(object: T, propKey: PropertyKey): propKey is MethodKeys<T> {
  return typeof object[propKey] === 'function';
}
